import React from 'react';
class PureRenderComponent extends React.PureComponent {}
export default PureRenderComponent;
